import { gql, useQuery } from "@apollo/client";
import { PublishedOffersOverviewAdminQueryQuery } from "../../../../../schemaTypes";

export const publishedOffersOverviewAdminQuery = gql`
  query PublishedOffersOverviewAdminQuery {
    publishedOffersOverviewAdmin {
      offerTypes {
        offerType
        count
      }
      totalOffers
    }
  }
`;

export interface OfferTypeOverviewAdmin {
  offerType: string;
  count: number;
}

export interface WithPublishedOffersOverviewAdmin {
  offerTypes: OfferTypeOverviewAdmin[];
  totalOffers: number;
}

interface Props {
  children: (data: WithPublishedOffersOverviewAdmin) => React.ReactElement | null;
}

export const PublishedOffersOverviewAdminController: React.FC<Props> = ({ children }) => {
  const { data } = useQuery<PublishedOffersOverviewAdminQueryQuery>(publishedOffersOverviewAdminQuery);
  const offerTypes = data?.publishedOffersOverviewAdmin.offerTypes ?? [];
  const totalOffers = data?.publishedOffersOverviewAdmin.totalOffers ?? 0;
  
  return children({ offerTypes, totalOffers });
};